var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"register-button mb-4",style:(("background-image: " + _vm.gradient)),attrs:{"dark":"","depressed":"","type":"submit","x-large":"","to":_vm.to ? _vm.to : '',"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }